import React, {Component} from 'react';
import "./luiss_ranking.scss";
import logo from '../../../assets/logo-text.png';

export interface LuissRankingData {
    text: string,
    image?: string;
}

class LuissRanking extends Component<LuissRankingData> {
    render() {
        return (
            <div className="luiss-ranking">
                <img src={this.props.image ? this.props.image : logo} alt="Luiss logo" className="luiss"/>
                <div className="text">{this.props.text}</div>
            </div>
        );
    }
}

export default LuissRanking;